import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { PageHeader, Card } from "../components/admin/AdminUI";
import DateInput from "../components/DateInput";
import { formatDmy, UNKNOWN_PAID_DATE } from "../utils/dateFormat";

// Kelas berbayar — hanya kelas ini yang punya tanggal bayar (kelas lain gratis).
const BILLABLE_CLASS_CODES = ["OT", "NT", "BD", "BLC", "BCMF", "HH", "CBH", "CBD", "BWG", "MMM"];
const todayJakarta = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());

// Tanggal bayar yang tampil di chip kelas (isian baru, atau yang tersimpan).
const paidDateLabel = (entry) => {
  if (entry.paidDate) return formatDmy(entry.paidDate);
  if (entry.paidDateUnknown && !entry.paidAt) return UNKNOWN_PAID_DATE;
  return entry.paidAt ? formatDmy(entry.paidAt) : "";
};

const EditStudentPage = ({ setLocationAdmin }) => {
  const navigate = useNavigate();
  const [errorMe, setErrorMe] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const id = useParams();

  const [studentId, setStudentId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  // Email saat halaman dibuka — URL sekarang berisi student.id, bukan email,
  // jadi ini yang dipakai untuk tahu apakah admin mengganti email.
  const [originalEmail, setOriginalEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dob, setDob] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postal, setPostal] = useState("");
  const [sp, setSp] = useState("");
  const [church, setChurch] = useState("");
  const [otherChurch, setOtherChurch] = useState("");
  const [classType, setClassType] = useState("");
  const [dj, setDj] = useState("");
  const [role, setRole] = useState("");
  const [programs, setPrograms] = useState("");
  const [classes, setClasses] = useState({
    className: [],
  });
  const [tshirtSize, setTshirtSize] = useState("");
  const [joined, setJoined] = useState("");
  const [year, setYear] = useState("");
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [batchJoined, setBtachJoined] = useState("");
  // Pembagian biaya (persen CEA / PIC / Other / student) — hanya ditampilkan.
  const [paymentSplit, setPaymentSplit] = useState(null);
  const [studentIdEditable, setStudentIdEditable] = useState(false);
  const [onLeave, setOnLeave] = useState(null);
  // Penanda mengikuti Orientation / Open Class. `specialReg*` = auto dari
  // data Special Reg (read-only, di-checklist otomatis kalau sudah daftar).
  const [attendedOrientation, setAttendedOrientation] = useState(false);
  const [attendedOpenClass, setAttendedOpenClass] = useState(false);
  const [specialRegOrientation, setSpecialRegOrientation] = useState(false);
  const [specialRegOpenClass, setSpecialRegOpenClass] = useState(false);
  const [leaveFromClass, setLeaveFromClass] = useState("");
  const [leaveToClass, setLeaveToClass] = useState("");
  const [leaveFromBatch, setLeaveFromBatch] = useState("");
  const [leaveToBatch, setLeaveToBatch] = useState("");

  const classOrder = [
    "OT",
    "NT",
    "BD",
    "BLC",
    "BCMF",
    "MASTERCLASS",
    "HH",
    "CBH",
    "CBD",
    "BWG",
    "MMM",
    "CONFERENCE",
  ];

  const class1Year = [
    { name: "OT", status: "completed" },
    { name: "NT", status: "completed" },
    { name: "BD", status: "completed" },
    { name: "BLC", status: "completed" },
    { name: "BCMF", status: "completed" },
    { name: "MASTERCLASS", status: "completed" },
    { name: "HH", status: "completed" },
    { name: "CBH", status: "completed" },
    { name: "CBD", status: "completed" },
    { name: "BWG", status: "completed" },
    { name: "MMM", status: "completed" },
    { name: "CONFERENCE", status: "completed" },
  ];

  const getMe = async () => {
    try {
      const response = await axios.get("/meAdmin");
    } catch (error) {
      setErrorMe(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`/student/${id.id}`);
      //   setData(response.data);
      setStudentId(response.data.studentId);
      setFullName(response.data.name);
      setEmail(response.data.email);
      setOriginalEmail(response.data.email || "");
      setPhone(response.data.phoneNumber);
      setDob(response.data.dateOfBirth);
      setAddress(response.data.address);
      setCity(response.data.city);
      setProvince(response.data.province);
      setPostal(response.data.postalCode);
      setSp(response.data.studentPackage);
      if (response.data.localChurch !== "IFGF Bandung") {
        setChurch("Others");
        setOtherChurch(response.data.localChurch);
      } else {
        setChurch(response.data.localChurch);
        setRole(response.data.role);
        setDj(response.data.lastDj);
      }
      setClassType(response.data.classType);
      setPrograms(response.data.program);
      setClasses(JSON.parse(response.data.classList));
      setTshirtSize(response.data.tshirtSize);
      setJoined(response.data.joinedCEA);
      setYear(response.data.yearJoined);
      setQ1(response.data.question1);
      setQ2(response.data.question2);
      setQ3(response.data.question3);
      setQ4(response.data.question4);
      setQ5(response.data.question5);
      setBtachJoined(response.data.batchJoined);
      setPaymentSplit(response.data.paymentSplit || null);
      // null = belum diputuskan → ikut Special Reg (auto). Kalau sudah ada
      // keputusan eksplisit admin (true/false), pakai itu (unmark bisa persist).
      const ao = response.data.attendedOrientation;
      const aoc = response.data.attendedOpenClass;
      setAttendedOrientation(ao === null || ao === undefined ? !!response.data.specialRegOrientation : !!ao);
      setAttendedOpenClass(aoc === null || aoc === undefined ? !!response.data.specialRegOpenClass : !!aoc);
      setSpecialRegOrientation(!!response.data.specialRegOrientation);
      setSpecialRegOpenClass(!!response.data.specialRegOpenClass);
      const existingLeave =
        typeof response.data.onLeave === "string"
          ? JSON.parse(response.data.onLeave)
          : response.data.onLeave;
      if (existingLeave) {
        setOnLeave(existingLeave);
        setLeaveFromClass(existingLeave.fromClass || "");
        setLeaveToClass(existingLeave.toClass || "");
        setLeaveFromBatch(existingLeave.fromBatch || "");
        setLeaveToBatch(existingLeave.toBatch || "");
      }
    } catch (error) {
      setErrorMe(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setLocationAdmin({ pathname: "/studentdatapage" });
    getMe();
    fetchData();
  }, []);

  //   console.log(data);
  // console.log(dj);

  // const handleCheckboxChange = (value) => {
  //   setClasses((prev) => {
  //     let updated;

  //     if (prev.className.includes(value)) {
  //       updated = prev.className.filter((item) => item !== value);
  //     } else {
  //       updated = [...prev.className, value];
  //     }

  //     updated.sort((a, b) => classOrder.indexOf(a) - classOrder.indexOf(b));

  //     return {
  //       ...prev,
  //       className: updated,
  //     };
  //   });
  // };

  const handleCheckboxChange = (value) => {
    setClasses((prev) => {
      const exists = prev.className.find((c) => c.name === value);

      let updated;

      if (exists) {
        updated = prev.className.filter((c) => c.name !== value);
      } else {
        // Default "requested" (belum dibayar) — lebih aman: kalau salah,
        // student tetap ditagih. Kalau default "completed", kelas itu tidak
        // akan pernah ditagih dan kesalahannya tidak terlihat.
        updated = [
          ...prev.className,
          { name: value, status: "requested", batch: batchJoined || "1" },
        ];
      }

      updated.sort(
        (a, b) => classOrder.indexOf(a.name) - classOrder.indexOf(b.name),
      );

      return {
        className: updated,
      };
    });
  };

  const handleAddBatch = (name, batch) => {
    setClasses((prev) => {
      const alreadyExists = prev.className.some(
        (c) => c.name === name && c.batch === batch,
      );
      if (alreadyExists) return prev;
      const updated = [
        ...prev.className,
        { name, status: "requested", batch },
      ];
      updated.sort(
        (a, b) =>
          classOrder.indexOf(a.name) - classOrder.indexOf(b.name) ||
          a.batch - b.batch,
      );
      return { className: updated };
    });
  };

  const handleRemoveBatch = (name, batch) => {
    setClasses((prev) => ({
      className: prev.className.filter(
        (c) => !(c.name === name && c.batch === batch),
      ),
    }));
  };

  // Perbaiki starting class 1 Year Program yang salah diisi saat mendaftar.
  // Backend menghitung ulang batch tiap kelas memakai helper yang sama dengan
  // registrasi, dan memetakan ulang kelas yang sudah lunas (jumlahnya tetap).
  const handleFixStartingClass = async () => {
    const options = {
      OT: "Old Testament Survey",
      NT: "New Testament Survey",
      BD: "Basic Doctrine",
      BLC: "Biblical Leadership and Communication",
      BCMF: "Biblical Counseling + Marriage and Family",
      HH: "Hermeneutic and Homiletic",
      CBH: "Church in The Bible and History",
      CBD: "Covenants and Biblical Discipleship",
      BWG: "Biblical Worship and Gatherings",
      MMM: "Mission and Marketplace Ministry",
    };
    const { value: sc, isConfirmed } = await Swal.fire({
      title: "Fix Starting Class",
      text: "Pick the class this student should actually start from. Batches will be recalculated; the number of classes already paid stays the same.",
      input: "select",
      inputOptions: options,
      inputPlaceholder: "Select starting class",
      background: "white",
      color: "black",
      showCancelButton: true,
      confirmButtonColor: "#fb3104",
      cancelButtonColor: "#d33",
      confirmButtonText: "Preview",
    });
    if (!isConfirmed || !sc) return;

    try {
      const prev = await axios.post(`/student/${id.id}/fix-starting-class`, {
        startingClass: sc,
        preview: true,
      });
      const { schedule, paidCount, currentClass } = prev.data;
      const rowsHtml = schedule
        .map((r) => {
          const color =
            r.status === "Paid" ? "#16a34a" : r.status === "Free" ? "#0ea5e9" : "#888";
          return `<tr>
            <td style="padding:5px 8px;font-size:13px;text-align:left;border-bottom:1px solid #eee;">${r.label}</td>
            <td style="padding:5px 8px;font-size:13px;text-align:left;border-bottom:1px solid #eee;">Batch ${r.batch}</td>
            <td style="padding:5px 8px;font-size:13px;text-align:left;border-bottom:1px solid #eee;color:${color};font-weight:700;">${r.status}</td>
          </tr>`;
        })
        .join("");

      const confirm = await Swal.fire({
        title: "Preview — new schedule",
        html: `
          <p style="font-size:13px;color:#555;margin:0 0 10px;text-align:left;">
            Currently running class: <strong>${currentClass || "-"}</strong> ·
            Classes already paid: <strong>${paidCount}</strong> (unchanged)
          </p>
          <div style="max-height:52vh;overflow-y:auto;">
            <table width="100%" style="border-collapse:collapse;">
              <thead><tr>
                <th style="padding:5px 8px;font-size:12px;color:#999;text-align:left;">Class</th>
                <th style="padding:5px 8px;font-size:12px;color:#999;text-align:left;">Batch</th>
                <th style="padding:5px 8px;font-size:12px;color:#999;text-align:left;">Status</th>
              </tr></thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </div>`,
        width: 620,
        background: "white",
        color: "black",
        showCancelButton: true,
        confirmButtonColor: "#fb3104",
        cancelButtonColor: "#d33",
        confirmButtonText: "Apply this",
      });
      if (!confirm.isConfirmed) return;

      const res = await axios.post(`/student/${id.id}/fix-starting-class`, {
        startingClass: sc,
        preview: false,
      });
      await Swal.fire({
        text: res.data.msg,
        icon: "success",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
      });
      fetchData();
    } catch (error) {
      Swal.fire({
        text: error.response?.data?.msg || "Failed to fix the starting class.",
        icon: "error",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
      });
    }
  };

  // Toggle status kelas: "completed" (sudah lunas / tidak ditagih lagi)
  // vs "requested" (belum dibayar / masih akan ditagih).
  // Unpaid → Paid untuk kelas berbayar WAJIB disertai tanggal bayar (dipakai
  // Financial Report), atau pernyataan admin tidak tahu tanggalnya (tercatat
  // "00-00-0000"). Backend menolak simpan kalau keduanya kosong.
  const updateEntry = (name, batch, fn) =>
    setClasses((prev) => ({
      className: prev.className.map((c) => (c.name === name && c.batch === batch ? fn(c) : c)),
    }));

  const handleToggleStatus = async (name, batch) => {
    const entry = classes.className.find((c) => c.name === name && c.batch === batch);
    if (!entry) return;

    if (entry.status === "completed") {
      updateEntry(name, batch, ({ paidDate, paidDateUnknown, ...rest }) => ({ ...rest, status: "requested" }));
      return;
    }
    if (!BILLABLE_CLASS_CODES.includes(name)) {
      updateEntry(name, batch, (c) => ({ ...c, status: "completed" }));
      return;
    }

    const today = todayJakarta();
    const result = await Swal.fire({
      title: `Mark ${name} (Batch ${batch}) as Paid`,
      html: `
        <p style="margin:0 0 12px;font-size:15px">When did the student pay for this class?<br/>
          <small style="color:#666">This date is used in the Financial Report.</small></p>
        <input type="date" id="paid-date" class="swal2-input" max="${today}"
          style="display:block;width:auto;margin:0 auto 14px" />
        <label style="display:inline-flex;gap:8px;align-items:flex-start;font-size:14px;text-align:left;cursor:pointer">
          <input type="checkbox" id="paid-date-unknown" style="margin-top:3px" />
          <span>I don't know the payment date<br/>
            <small style="color:#666">It will be recorded as ${UNKNOWN_PAID_DATE}.</small></span>
        </label>`,
      background: "white",
      color: "black",
      showCancelButton: true,
      confirmButtonColor: "#fb3104",
      cancelButtonColor: "#d33",
      confirmButtonText: "Mark as Paid",
      focusConfirm: false,
      didOpen: () => {
        const box = document.getElementById("paid-date-unknown");
        const input = document.getElementById("paid-date");
        box.addEventListener("change", () => {
          input.disabled = box.checked;
          if (box.checked) input.value = "";
        });
      },
      preConfirm: () => {
        const unknown = document.getElementById("paid-date-unknown").checked;
        const date = document.getElementById("paid-date").value;
        if (unknown) return { unknown: true };
        if (!date) {
          Swal.showValidationMessage('Please choose the payment date, or tick "I don\'t know the payment date".');
          return false;
        }
        if (date > today) {
          Swal.showValidationMessage("The payment date cannot be in the future.");
          return false;
        }
        return { unknown: false, date };
      },
    });
    if (!result.isConfirmed) return;

    const { unknown, date } = result.value;
    updateEntry(name, batch, ({ paidDate, paidDateUnknown, ...rest }) => ({
      ...rest,
      status: "completed",
      ...(unknown ? { paidDateUnknown: true } : { paidDate: date }),
    }));
  };

  const handleCancel = async () => {
    const result = await Swal.fire({
      html: `
    Unsaved changes<br/>
    Do you want to cancel?
  `,
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      navigate("/studentdatapage");
    } else if (result.isDismissed) {
    }
  };

  const handleSubmit = async () => {
    const leaveFieldsFilled = [leaveFromClass, leaveToClass, leaveFromBatch, leaveToBatch].filter(
      (v) => v !== "",
    ).length;
    if (leaveFieldsFilled > 0 && leaveFieldsFilled < 4) {
      await Swal.fire({
        text: 'Leave (Cuti) section is incomplete. Fill in all 4 fields (From Class, From Batch, To Class, To Batch), or click "Clear Leave" to remove it entirely.',
        icon: "error",
        background: "white",
        color: "black",
        confirmButtonColor: "#0004ff",
        confirmButtonText: "OK",
      });
      return;
    }

    const result = await Swal.fire({
      text: "Do you want to save changes ?",
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });

    if (!result.isConfirmed) return;

    let finalDj = dj;
    let finalRole = role;
    let finalClasses = classes;
    let finalYear = year;
    let finalq1 = q1;
    let finalq2 = q2;
    let finalq3 = q3;
    let finalq4 = q4;
    let finalq5 = q5;

    if (church !== "IFGF Bandung") {
      finalDj = "";
      finalRole = "";
    }

    try {
      const payload = {
        studentId: studentId,
        name: fullName,
        email: email,
        phoneNumber: phone,
        dateOfBirth: dob,
        address: address,
        city: city,
        province: province,
        postalCode: postal,
        studentPackage: sp,
        localChurch: church === "Others" ? otherChurch : church,
        lastDj: finalDj,
        role: finalRole,
        classType: classType,
        programs: programs,
        tshirtSize: tshirtSize,
        classes: finalClasses,
        joinedCEA: joined,
        year: finalYear,
        question1: finalq1,
        question2: finalq2,
        question3: finalq3,
        question4: finalq4,
        question5: finalq5,
        batchJoined: batchJoined,
        onLeave:
          leaveFromClass && leaveToClass && leaveFromBatch && leaveToBatch
            ? {
                fromClass: leaveFromClass,
                toClass: leaveToClass,
                fromBatch: leaveFromBatch,
                toBatch: leaveToBatch,
              }
            : null,
        // Simpan keputusan eksplisit admin (checkbox sudah mencakup auto dari
        // Special Reg sebagai nilai awal, tapi admin boleh unmark).
        attendedOrientation: attendedOrientation,
        attendedOpenClass: attendedOpenClass,
      };

      const saved = await axios.patch(`/studentadmin/${id.id}`, payload);

      // Kalau email diganti, server memindahkan semua data student itu ke
      // email baru; pesannya menyebut berapa baris yang ikut pindah.
      const emailChanged =
        saved.data?.email && saved.data.email.toLowerCase() !== originalEmail.trim().toLowerCase();

      // packageNote: info dari sinkron Orientation ↔ Student Package (mis.
      // barang Student Orientation tetap "received" walau centangnya dilepas).
      const savedText = emailChanged ? saved.data.msg : "Data saved successfully!";
      const result2 = await Swal.fire({
        text: saved.data?.packageNote ? `${savedText} ${saved.data.packageNote}` : savedText,
        icon: "success",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        confirmButtonColor: "#0004ff",
        confirmButtonText: "OK",
        customClass: { confirmButton: "custom-btn-sweetalrt" },
      });

      if (result2.isConfirmed) {
        navigate("/studentdatapage");
      }
    } catch (error) {
      Swal.fire({
        title: "Cannot Save",
        text: error?.response?.data?.msg || "Something went wrong. Please try again.",
        icon: "error",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (errorMe) {
      Swal.fire({
        title: "Session Expired",
        text: "Please login to your account !",
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });

      navigate("/loginAdmin");
    }
  }, [errorMe, navigate]);

  // Daftar kelas + chip batch per kelas. Dipakai untuk 1 Year Program maupun
  // 1 Month Course (sebelumnya ditulis dua kali dengan isi yang sama).
  const renderClassEditor = () =>
    CLASS_LIST.map(({ code, label }) => {
      const entries = classes.className.filter((c) => c.name === code);
      const isChecked = entries.length > 0;
      const usedBatches = entries.map((e) => e.batch);
      // +2 agar admin tetap bisa assign kelas mid-batch student ke batchJoined+1/+2
      const maxBatch = (parseInt(batchJoined) || 4) + 2;
      const availableBatches = Array.from({ length: maxBatch }, (_, i) => String(i + 1)).filter(
        (b) => !usedBatches.includes(b),
      );
      return (
        <div key={code} className={`adm-class-row${isChecked ? " adm-class-row--on" : ""}`}>
          <label className="adm-class-check">
            <input
              type="checkbox"
              value={code}
              checked={isChecked}
              onChange={() => handleCheckboxChange(code)}
              // Kelas yang dibayar online tidak boleh dihapus (lihat Financial Report).
              disabled={entries.some((e) => e.paymentMethod === "gateway")}
              title={entries.some((e) => e.paymentMethod === "gateway") ? "Paid online — this class cannot be removed" : undefined}
            />
            <span className="adm-class-code">{code}</span>
            <span className="adm-class-name">{label}</span>
          </label>
          {isChecked && (
            <div className="adm-class-batches">
              {entries.map((entry) => {
                const isPaid = entry.status === "completed";
                // Dibayar lewat link pembayaran online → terkunci. Koreksi /
                // refund dicatat sebagai catatan di Financial Report.
                const locked = entry.paymentMethod === "gateway";
                return (
                  <span key={entry.batch} className={`adm-batch-chip ${isPaid ? "adm-batch-chip--paid" : "adm-batch-chip--unpaid"}`}>
                    Batch {entry.batch}
                    <button
                      type="button"
                      className="adm-batch-chip-status"
                      onClick={() => !locked && handleToggleStatus(code, entry.batch)}
                      disabled={locked}
                      title={
                        locked
                          ? "Paid online — locked. Add a note in Financial Report for refunds."
                          : isPaid
                            ? "Click to mark Unpaid"
                            : "Click to mark Paid — you'll be asked for the payment date"
                      }
                    >
                      {locked && <i className="bi bi-lock-fill" style={{ marginRight: "3px", fontSize: "10px" }}></i>}
                      {isPaid ? "Paid" : "Unpaid"}
                    </button>
                    {isPaid && paidDateLabel(entry) && (
                      <span style={{ fontSize: "11px", opacity: 0.85, marginLeft: "4px", whiteSpace: "nowrap" }}>
                        {paidDateLabel(entry)}
                      </span>
                    )}
                    {!locked && (
                      <button
                        type="button"
                        className="adm-batch-chip-remove"
                        aria-label={`Remove batch ${entry.batch}`}
                        onClick={() => handleRemoveBatch(code, entry.batch)}
                      >
                        ×
                      </button>
                    )}
                  </span>
                );
              })}
              {availableBatches.length > 0 && (
                <select
                  className="form-select form-select-sm"
                  style={{ width: "auto", minWidth: "120px" }}
                  value=""
                  onChange={(e) => {
                    if (e.target.value) handleAddBatch(code, e.target.value);
                    e.target.value = "";
                  }}
                >
                  <option value="">+ Add batch</option>
                  {availableBatches.map((b) => (
                    <option key={b} value={b}>
                      Batch {b}
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}
        </div>
      );
    });

  const radioGroup = (name, value, onChange, options) => (
    <div className="adm-radio-group">
      {options.map((opt) => (
        <label key={opt.value} className={`adm-radio${value === opt.value ? " adm-radio--on" : ""}`}>
          <input type="radio" name={name} value={opt.value} checked={value === opt.value} onChange={(e) => onChange(e.target.value)} />
          {opt.label}
        </label>
      ))}
    </div>
  );

  return (
    <div className="adm-main">
      <button
        type="button"
        className="adm-btn adm-btn--ghost adm-btn--sm"
        style={{ marginBottom: "8px", paddingLeft: 0 }}
        onClick={handleCancel}
      >
        <i className="bi bi-arrow-left"></i> Back to Student Data
      </button>
      <PageHeader title="Edit Student" subtitle={[fullName, studentId].filter(Boolean).join(" · ")} />

      <form onSubmit={(e) => e.preventDefault()}>
        {/* ── Identitas ── */}
        <Card title="Identity">
          <div className="adm-form-grid">
            <div>
              <label className="form-label">Student ID</label>
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Student ID"
                  value={studentId || ""}
                  readOnly={!studentIdEditable}
                  onChange={(e) => setStudentId(e.target.value)}
                  style={{
                    backgroundColor: studentIdEditable ? "#fff" : "#f5f5f6",
                    cursor: studentIdEditable ? "text" : "not-allowed",
                    borderColor: studentIdEditable ? "var(--adm-primary)" : undefined,
                  }}
                />
                {!studentIdEditable ? (
                  <button
                    type="button"
                    className="adm-btn adm-btn--secondary"
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Edit Student ID?",
                        html: `Changing the Student ID can break student login and data references.<br/><br/>Are you sure you want to edit this?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes, I understand",
                        cancelButtonText: "Cancel",
                      });
                      if (result.isConfirmed) {
                        setStudentIdEditable(true);
                      }
                    }}
                  >
                    <i className="bi bi-unlock"></i> Edit ID
                  </button>
                ) : (
                  <button type="button" className="adm-btn adm-btn--secondary" onClick={() => setStudentIdEditable(false)}>
                    <i className="bi bi-lock"></i> Lock
                  </button>
                )}
              </div>
            </div>
            <div>
              <label className="form-label">Full Name</label>
              <input type="text" className="form-control" placeholder="Full Name" value={fullName || ""} onChange={(e) => setFullName(e.target.value)} />
            </div>
            <div>
              <label className="form-label">Email</label>
              <input type="email" className="form-control" placeholder="example@gmail.com" value={email || ""} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="form-label">WhatsApp Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="6287xxxxxxxxx"
                value={phone || ""}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              />
            </div>
            <div>
              <label className="form-label">Date of Birth</label>
              <DateInput className="form-control" value={dob || ""} onChange={(e) => setDob(e.target.value)} />
            </div>
          </div>
        </Card>

        {/* ── Alamat ── */}
        <Card title="Address" className="adm-section">
          <div className="adm-form-grid">
            <div className="adm-span-all">
              <label className="form-label">Address (Indonesia Address)</label>
              <textarea rows="2" className="form-control" placeholder="Insert your address" value={address || ""} onChange={(e) => setAddress(e.target.value)}></textarea>
            </div>
            <div>
              <label className="form-label">City</label>
              <input type="text" className="form-control" placeholder="City" value={city || ""} onChange={(e) => setCity(e.target.value)} />
            </div>
            <div>
              <label className="form-label">Province</label>
              <input type="text" className="form-control" placeholder="Province" value={province || ""} onChange={(e) => setProvince(e.target.value)} />
            </div>
            <div>
              <label className="form-label">Postal Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Postal Code"
                value={postal || ""}
                onChange={(e) => setPostal(e.target.value.replace(/\D/g, ""))}
              />
            </div>
            <div className="adm-span-all">
              <label className="form-label">Student Package</label>
              {radioGroup("sp", sp, setSp, [
                { value: "The House Convention Hall", label: "The House Convention Hall" },
                { value: "Shipping", label: "Shipping (only for student outside Bandung)" },
              ])}
            </div>
          </div>
        </Card>

        {/* ── Gereja & Peran ── */}
        <Card title="Church & Role" className="adm-section">
          <div className="adm-form-grid">
            <div>
              <label className="form-label">Church</label>
              <select className="form-select" value={church || ""} onChange={(e) => setChurch(e.target.value)}>
                <option value="">Select Local Church</option>
                <option value="IFGF Bandung">IFGF Bandung</option>
                <option value="Others">Others</option>
              </select>
            </div>
            {church === "IFGF Bandung" && (
              <>
                <div>
                  <label className="form-label">Last DJ Class</label>
                  <select className="form-select" value={dj || ""} onChange={(e) => setDj(e.target.value)}>
                    <option value="">Select DJ Class</option>
                    <option value="Come">Come</option>
                    <option value="Grow">Grow</option>
                    <option value="Serve">Serve</option>
                    <option value="Lead">Lead</option>
                    <option value="None">None</option>
                  </select>
                </div>
                <div>
                  <label className="form-label">Role</label>
                  <select className="form-select" value={role || ""} onChange={(e) => setRole(e.target.value)}>
                    <option value="">Select Role</option>
                    <option value="HITS/MTh Student">HITS/Mth Student</option>
                    <option value="Pastoral">Pastoral</option>
                    <option value="Staff">Staff</option>
                    <option value="Coach">Coach</option>
                    <option value="Care Group Leader (CGL)">Care Group Leader (CGL)</option>
                    <option value="Core Team Leader (CTL)">Core Team Leader (CTL)</option>
                    <option value="Attendees (IFGF BDG)">Attendees (IFGF BDG)</option>
                  </select>
                </div>
              </>
            )}
            {church === "Others" && (
              <div>
                <label className="form-label">Local Church</label>
                <input type="text" className="form-control" placeholder="Input Local Church" value={otherChurch || ""} onChange={(e) => setOtherChurch(e.target.value)} />
              </div>
            )}
          </div>
        </Card>

        {/* ── Program & kelas ── */}
        <Card
          title="Program & Classes"
          className="adm-section"
          actions={
            programs === "1 Year Program" && (
              <button type="button" className="adm-btn adm-btn--dark adm-btn--sm" onClick={handleFixStartingClass}>
                Fix Starting Class
              </button>
            )
          }
        >
          {paymentSplit && <PaymentSplitInfo split={paymentSplit} />}
          <div className="adm-form-grid" style={{ marginBottom: "18px" }}>
            <div>
              <label className="form-label">Program</label>
              <select className="form-select" value={programs || ""} onChange={(e) => setPrograms(e.target.value)}>
                <option value="">Select program</option>
                <option value="1 Year Program">1 Year Program</option>
                <option value="1 Month Course">1 Month Course</option>
              </select>
            </div>
            {programs === "1 Year Program" && (
              <div>
                <label className="form-label">T-shirt Size</label>
                <select className="form-select" value={tshirtSize || ""} onChange={(e) => setTshirtSize(e.target.value)}>
                  <option value="">Select Size</option>
                  <option value="s">S (Lebar Dada = 52cm | Panjang Baju 67cm)</option>
                  <option value="m">M (Lebar Dada = 55cm | Panjang Baju 68cm)</option>
                  <option value="l">L (Lebar Dada = 58cm | Panjang Baju 72cm)</option>
                  <option value="xl">XL (Lebar Dada = 61cm | Panjang Baju 76cm)</option>
                  <option value="xxl">XXL (Lebar Dada = 63cm | Panjang Baju 80cm)</option>
                </select>
              </div>
            )}
            <div className="adm-span-all">
              <label className="form-label">Online / Onsite</label>
              {radioGroup("classType", classType, setClassType, [
                { value: "Online", label: "Online" },
                { value: "Onsite", label: "Onsite" },
              ])}
            </div>
          </div>

          {(programs === "1 Year Program" || programs === "1 Month Course") && (
            <>
              <p className="adm-form-section-title">
                {programs === "1 Year Program" ? "Class batch per subject" : "Classes joined"}
              </p>
              {programs === "1 Year Program" && (
                <p className="adm-help" style={{ margin: "-6px 0 12px" }}>
                  Click <strong>Paid / Unpaid</strong> on a batch chip to change whether that class still gets billed.
                  Marking a class <strong>Paid</strong> asks for the payment date (or {UNKNOWN_PAID_DATE} if it is not known).
                  Use <strong>Fix Starting Class</strong> if the student picked the wrong starting class when registering —
                  batches are recalculated automatically and the number of paid classes stays the same.
                </p>
              )}
              <div className="adm-class-list">{renderClassEditor()}</div>
            </>
          )}
        </Card>

        {/* ── Cuti ── */}
        <Card
          title="Leave (Cuti)"
          className="adm-section"
          actions={
            (leaveFromClass || leaveToClass || leaveFromBatch || leaveToBatch) && (
              <button
                type="button"
                className="adm-btn adm-btn--danger adm-btn--sm"
                onClick={() => {
                  setLeaveFromClass("");
                  setLeaveToClass("");
                  setLeaveFromBatch("");
                  setLeaveToBatch("");
                }}
              >
                Clear Leave
              </button>
            )
          }
        >
          <div className="adm-form-grid adm-form-grid--4">
            <div>
              <label className="form-label">From Class</label>
              <select className="form-select" value={leaveFromClass} onChange={(e) => setLeaveFromClass(e.target.value)}>
                <option value="">-</option>
                {classOrder.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="form-label">From Batch</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. 4"
                value={leaveFromBatch}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  setLeaveFromBatch(val);
                  // Auto-fill To Batch for the common same-batch case, but don't
                  // clobber it if admin already set a different value on purpose.
                  setLeaveToBatch((prev) => (prev === "" ? val : prev));
                }}
              />
            </div>
            <div>
              <label className="form-label">To Class</label>
              <select className="form-select" value={leaveToClass} onChange={(e) => setLeaveToClass(e.target.value)}>
                <option value="">-</option>
                {classOrder.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="form-label">To Batch</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. 4"
                value={leaveToBatch}
                onChange={(e) => setLeaveToBatch(e.target.value.replace(/\D/g, ""))}
              />
            </div>
          </div>
          <p className="adm-help" style={{ marginTop: "10px" }}>
            Jika cuti menyeberang batas batch (mis. MMM batch 4 sampai MASTERCLASS batch 5),
            isi "To Batch" dengan batch selanjutnya. Jika masih dalam satu batch, isi "From Batch"
            dan "To Batch" dengan angka yang sama.
          </p>
        </Card>

        {/* ── Kehadiran ── */}
        <Card title="Attendance" subtitle="Auto-checked when the student registered through Special Reg — you can still change it manually." className="adm-section">
          <div className="d-flex flex-column gap-2">
            <label className="adm-check">
              <input type="checkbox" checked={attendedOrientation} onChange={(e) => setAttendedOrientation(e.target.checked)} />
              Has attended Orientation
            </label>
            <p className="adm-help" style={{ margin: "-4px 0 4px 26px" }}>
              Saving with this checked also marks the Student Orientation package item as received. Unchecking it does not undo
              that — revert it in Student Package if needed.
            </p>
            <label className="adm-check">
              <input type="checkbox" checked={attendedOpenClass} onChange={(e) => setAttendedOpenClass(e.target.checked)} />
              Has attended Open Class
            </label>
          </div>
        </Card>

        {/* ── Pertanyaan ── */}
        <Card title="Questions" className="adm-section">
          <div className="d-flex flex-column gap-3">
            <div>
              <label className="form-label">Have you ever joined Cutting Edge Academy before?</label>
              {radioGroup("joined", joined, setJoined, [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ])}
            </div>
            {[
              { label: "Bagaimana kisah perjalanan kekristenan Anda, ketika Anda mengalami lahir baru hingga saat ini?", value: q1, set: setQ1 },
              { label: "Apakah Anda sudah mengalami baptisan?", value: q2, set: setQ2 },
              { label: "Ceritakan beberapa pengalaman pelayanan Anda dan buah dari pelayanan-pelayanan tersebut.", value: q3, set: setQ3 },
              { label: "Apa rencana dan langkah Anda selanjutnya setelah mengikuti Cutting Edge Academy?", value: q4, set: setQ4 },
              { label: "Mengapa Anda ingin bergabung dengan Cutting Edge Academy?", value: q5, set: setQ5 },
            ].map((q, i) => (
              <div key={i}>
                <label className="form-label">
                  {i + 1}. {q.label}
                </label>
                <textarea rows="2" className="form-control" value={q.value || ""} onChange={(e) => q.set(e.target.value)}></textarea>
              </div>
            ))}
          </div>
        </Card>
      </form>

      <div className="adm-card adm-section" style={{ position: "sticky", bottom: "16px", zIndex: 5 }}>
        <div className="adm-card-body d-flex justify-content-end gap-2" style={{ padding: "14px 18px" }}>
          <button type="button" className="adm-btn adm-btn--secondary" onClick={handleCancel}>
            Cancel
          </button>
          <button type="button" className="adm-btn adm-btn--primary" onClick={handleSubmit}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

const CLASS_LIST = [
  { code: "OT", label: "Old Testament Survey" },
  { code: "NT", label: "New Testament Survey" },
  { code: "BD", label: "Basic Doctrine" },
  { code: "BLC", label: "Biblical Leadership and Communication" },
  { code: "BCMF", label: "Biblical Counseling + Marriage and Family" },
  { code: "MASTERCLASS", label: "Masterclass" },
  { code: "HH", label: "Hermeneutic and Homiletic" },
  { code: "CBH", label: "Church in The Bible and History" },
  { code: "CBD", label: "Covenants and Biblical Discipleship" },
  { code: "BWG", label: "Biblical Worship and Gatherings" },
  { code: "MMM", label: "Mission and Marketplace Ministry" },
  { code: "CONFERENCE", label: "Conference" },
];

// Ringkasan diskon / pembagian biaya student (read-only).
const PaymentSplitInfo = ({ split }) => {
  const sourceLabel =
    split.source === "church"
      ? `CEA To Church${split.churchName ? ` · ${split.churchName}` : ""}`
      : split.source === "scholarship"
        ? "Scholarship"
        : "Regular Registration";
  const parts = [
    { key: "cea", label: "CEA discount", value: split.cea, className: "adm-badge--primary" },
    { key: "pic", label: "PIC", value: split.pic, className: "adm-badge--warning", hideZero: split.source !== "church" },
    { key: "other", label: "Other payer", value: split.other, className: "adm-badge--info", hideZero: true },
    { key: "student", label: "Student pays", value: split.student, className: "adm-badge--success" },
  ].filter((p) => !(p.hideZero && !p.value));

  return (
    <div
      style={{
        border: "1px solid var(--adm-border-soft)",
        borderRadius: "10px",
        padding: "12px 14px",
        marginBottom: "18px",
        background: "var(--adm-surface-2, #fafafa)",
      }}
    >
      <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: ".04em", textTransform: "uppercase", color: "var(--adm-muted)", marginBottom: "8px" }}>
        Discount &amp; Payment Share
      </div>
      <div className="adm-badges" style={{ flexWrap: "wrap", gap: "6px" }}>
        <span className="adm-badge adm-badge--purple">{sourceLabel}</span>
        {parts.map((p) => (
          <span key={p.key} className={`adm-badge ${p.className}`}>
            {p.label} {p.value}%
          </span>
        ))}
      </div>
    </div>
  );
};

export default EditStudentPage;
